module.exports = __webpack_public_path__ + "static/media/blue_sky.beee3554.png";